'use client'

import getLocale from '@/stores/locales'
import { FILTERS_ICONS } from '@/utils/constants'
import PhIcon from '@mercadoni/sinister/dist/cjs/PhIcon'

const AggregateIcon = ({ icon }: { icon: string }) => {
  if (icon?.length) {
    const style = {
      color: '#262626',
      verticalAlign: 'text-top',
      marginRight: '10px',
    }
    return <PhIcon size={18} style={style} className={icon} />
  }
  return null
}

const Label = ({ aggregateName }: { aggregateName: string }) => {
  const copy = getLocale()
  const { aggregates = {} } = copy?.filter || {}
  const icon =
    FILTERS_ICONS?.[aggregateName as keyof typeof FILTERS_ICONS] || ''
  const name = aggregates[aggregateName] || ''
  return (
    <>
      <AggregateIcon icon={icon} />
      {name}
    </>
  )
}

export default Label
